<script lang="ts">
    import type { RouteLocation } from "../routing/route_location";
    import MenubarLink from "./MenubarLink.svelte";
    import { LOCATION } from "../routing/contexts";
    import { getContext } from "svelte";

    const location: SvelteStore<RouteLocation> = getContext(LOCATION);
</script>

<nav data-nosnippet="data-nosnippet">
    <ul>
        <a class="logo-container" href="/">
            <picture>
                <source srcset="/static/logo.svg" media="(min-width: 800px)" />
                <source srcset="/static/logo_w256.webp" />
                <img src="/static/logo_w256.png" class="logo" alt="Fjälltoppen" />
            </picture>
        </a>
        <li><MenubarLink location={$location} url="/start">Sök</MenubarLink></li>
        <li><MenubarLink location={$location} url="/skidorter">Skidorter</MenubarLink></li>
        <li><MenubarLink location={$location} url="/om-oss">Om oss</MenubarLink></li>
    </ul>
</nav>

<style>
</style>
